import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialog) = $event)),
    title: "Modifier le libellé",
    validTitle: "Confirmer les modifications",
    onValid: _cache[5] || (_cache[5] = ($event: any) => (_ctx.update())),
    onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.cancelChangingName())),
    validLoading: _ctx.changeWordingLoading,
    "min-width": "70vw"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12 mb-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_oss_date_picker_filled, {
                modelValue: _ctx.date,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event)),
                filterWithoutClosedAccountingPeriods: !_ctx.readOnly,
                label: _ctx.$t('shared.debitDate'),
                textFieldReadOnly: _ctx.readOnly,
                readOnly: _ctx.readOnly
              }, null, 8, ["modelValue", "filterWithoutClosedAccountingPeriods", "label", "textFieldReadOnly", "readOnly"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "12 mb-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field_filled, {
                modelValue: _ctx.wording,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.wording) = $event)),
                label: "Libellé",
                readOnly: _ctx.readOnly
              }, null, 8, ["modelValue", "readOnly"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "12 mb-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field_filled, {
                label: "Libellé court",
                readonly: "",
                "model-value": _ctx.bankTransaction.wordingLight
              }, null, 8, ["model-value"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            class: "d-flex justify-end"
          }, {
            default: _withCtx(() => [
              (!_ctx.displayActivity)
                ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                    key: 0,
                    class: "mr-1",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.displayActivity = true)),
                    size: "small",
                    icon: "$oss-activity"
                  }))
                : _createCommentVNode("", true),
              (_ctx.displayActivity)
                ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                    key: 1,
                    class: "mr-1 rounded",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.displayActivity = false)),
                    size: "small",
                    icon: "$oss-close"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_btn, {
                class: "mr-1",
                disabled: !_ctx.isInAccountingFirm && !_ctx.isBusinessClient,
                onClick: _ctx.openWordingAnalysisEdition
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode(" Analyse de libellés ")
                ])),
                _: 1
              }, 8, ["disabled", "onClick"]),
              (_ctx.toCorrect)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 2,
                    color: "error",
                    class: "mr-1",
                    onClick: _ctx.correctBT
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode(" Corriger ")
                    ])),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.displayActivity)
        ? (_openBlock(), _createBlock(_component_UsersActivitiesHistory, {
            key: 0,
            bankTransactionId: _ctx.bankTransaction.id
          }, null, 8, ["bankTransactionId"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "validLoading"]))
}